/**
 * Maps heading style keys to their corresponding font class strings.
 * Used to apply the correct font styling for different heading styles in the UI.
 *
 * Example usage:
 *   const fontClass = fontClassMappings["heading-3xl-light"];
 *   // fontClass = "Trade_Gothic_Header_32_105_0_300 md:Trade_Gothic_Header_56_100_0_300"
 */
export const fontClassMappings: Record<string, string> = {
    // Trade Gothic mappings
    "heading-5xl-light":
        "Trade_Gothic_Header_48_105_0_300 md:Trade_Gothic_Header_96_100_-1_300",
    "heading-4xl-light":
        "Trade_Gothic_Header_40_105_0_300 md:Trade_Gothic_Header_64_100_-1_300",
    "heading-3xl-light":
        "Trade_Gothic_Header_32_105_0_300 md:Trade_Gothic_Header_56_100_0_300",
    "heading-2xl-light":
        "Trade_Gothic_Header_32_105_0_300 md:Trade_Gothic_Header_48_105_0_300",
    "heading-xl-light":
        "Trade_Gothic_Header_24_145_0_300 md:Trade_Gothic_Header_40_105_0_300",
    "heading-lg-light":
        "Trade_Gothic_Header_24_145_0_300 md:Trade_Gothic_Header_32_105_0_300",
    "heading-md-light": "Trade_Gothic_Header_24_145_0_300",
    "heading-5xl-bold":
        "Trade_Gothic_Header_48_105_0_700_uppercase md:Trade_Gothic_Header_96_100_-1_700_uppercase",
    "heading-4xl-bold":
        "Trade_Gothic_Header_40_105_0_700_uppercase md:Trade_Gothic_Header_64_100_-1_700_uppercase",
    "heading-3xl-bold":
        "Trade_Gothic_Header_32_105_0_700_uppercase md:Trade_Gothic_Header_56_100_0_700_uppercase",
    "heading-2xl-bold":
        "Trade_Gothic_Header_32_105_0_700_uppercase md:Trade_Gothic_Header_48_105_0_700_uppercase",
    "heading-xl-bold":
        "Trade_Gothic_Header_24_125_0_700_uppercase md:Trade_Gothic_Header_40_105_0_700_uppercase",
    "heading-lg-bold":
        "Trade_Gothic_Header_24_125_0_700_uppercase md:Trade_Gothic_Header_32_105_0_700_uppercase",
    "heading-md-bold": "Trade_Gothic_Header_24_145_0_700_uppercase",
    // Trim Mono mappings
    "trim-heading-5xl-light":
        "Trim_Mono_POC_Header_48_110_3_300_uppercase md:Trim_Mono_POC_Header_96_90_10_300_uppercase",
    "trim-heading-4xl-light":
        "Trim_Mono_POC_Header_40_110_2_300_uppercase md:Trim_Mono_POC_Header_64_100_4_300_uppercase",
    "trim-heading-3xl-light":
        "Trim_Mono_POC_Header_32_130_1_300_uppercase md:Trim_Mono_POC_Header_56_110_3_300_uppercase",
    "trim-heading-2xl-light":
        "Trim_Mono_POC_Header_32_130_1_300_uppercase md:Trim_Mono_POC_Header_48_110_3_300_uppercase",
    "trim-heading-xl-light":
        "Trim_Mono_POC_Header_24_130_1_300_uppercase md:Trim_Mono_POC_Header_40_110_2_300_uppercase",
    "trim-heading-lg-light":
        "Trim_Mono_POC_Header_24_130_1_300_uppercase md:Trim_Mono_POC_Header_32_130_1_300_uppercase",
    "trim-heading-md-light": "Trim_Mono_POC_Header_24_130_1_300_uppercase",
    "trim-heading-sm-light": "Trim_Mono_POC_Header_20_130_1_300_uppercase",
    "trim-heading-5xl-regular":
        "Trim_Mono_Regular_POC_Header_48_110_3_300_uppercase md:Trim_Mono_Regular_POC_Header_96_90_10_300_uppercase",
    "trim-heading-4xl-regular":
        "Trim_Mono_Regular_POC_Header_40_110_2_300_uppercase md:Trim_Mono_Regular_POC_Header_64_100_4_300_uppercase",
    "trim-heading-3xl-regular":
        "Trim_Mono_Regular_POC_Header_32_130_1_300_uppercase md:Trim_Mono_Regular_POC_Header_56_110_3_300_uppercase",
    "trim-heading-2xl-regular":
        "Trim_Mono_Regular_POC_Header_32_130_1_300_uppercase md:Trim_Mono_Regular_POC_Header_48_110_3_300_uppercase",
    "trim-heading-xl-regular":
        "Trim_Mono_Regular_POC_Header_24_130_1_400_uppercase md:Trim_Mono_Regular_POC_Header_40_110_2_300_uppercase",
    "trim-heading-lg-regular":
        "Trim_Mono_Regular_POC_Header_24_130_1_400_uppercase md:Trim_Mono_Regular_POC_Header_32_130_1_300_uppercase",
    "trim-heading-md-regular": "Trim_Mono_Regular_POC_Header_24_130_1_400_uppercase",
    "trim-heading-sm-regular": "Trim_Mono_Regular_POC_Header_20_130_1_300_uppercase"
}
